module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/assessment_achievements/3_fd47550566b2fafa28941bd843e4fac0.png";